import { useCallback, useEffect, useState } from 'react';

import { useReactFlow } from '@xyflow/react';

import { subscriptions } from '../listeners';

const useFlowEvents = (isReadOnly) => {
  const reactflow = useReactFlow();
  const subs = subscriptions(reactflow);

  const [events, setEvents] = useState({
    onReconnectStart: false,
    onConnectStart: false,
    onConnect: false,
    onReconnect: false,
    onConnectEnd: false,
    onReconnectEnd: false,
  });

  const resetEvents = useCallback(() => {
    setEvents({
      onReconnectStart: false,
      onConnectStart: false,
      onConnect: false,
      onReconnect: false,
      onConnectEnd: false,
      onReconnectEnd: false,
    });
  }, []);

  const onReconnectStart = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onReconnectStart: true,
      }));
      subs.onReconnectStart(params);
    },
    [isReadOnly, subs]
  );

  const onConnectStart = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onConnectStart: true,
      }));
      subs.onConnectStart(params);
    },
    [isReadOnly, subs]
  );

  const onConnect = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onConnect: true,
      }));
      subs.onConnect(params);
    },
    [isReadOnly, subs]
  );

  const onReconnect = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onReconnect: true,
      }));
      subs.onReconnect(params);
    },
    [isReadOnly, subs]
  );

  const onConnectEnd = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onConnectEnd: true,
      }));
      subs.onConnectEnd(params);
    },
    [isReadOnly, subs]
  );

  const onReconnectEnd = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onReconnectEnd: true,
      }));
      subs.onReconnectEnd(params);
    },
    [isReadOnly, subs]
  );

  const onEdgesDelete = useCallback(
    (params) => {
      if (isReadOnly) return;
      setEvents((events) => ({
        ...events,
        onEdgesDelete: true,
      }));
      subs.onEdgesDelete(params);
    },
    [isReadOnly, subs]
  );

  useEffect(() => {
    if (!events.onReconnectEnd && !events.onConnectEnd) return;

    const timer = window.setTimeout(() => {
      resetEvents();
    }, 500);

    return () => window.clearTimeout(timer);
  }, [events, resetEvents]);

  return {
    events,
    onReconnectStart,
    onConnectStart,
    onConnect,
    onReconnect,
    onConnectEnd,
    onReconnectEnd,
    onEdgesDelete,
  };
};

export default useFlowEvents;
